import { useState, useCallback } from 'react';

export default function useToken() {
    const [token, setTokenState] = useState(() => {
        const localString = localStorage.getItem('token');
        const sessionString = sessionStorage.getItem('token');
        if (localString && !sessionString) {
            sessionStorage.setItem('token', localString);
        }
        const tokenString = localString || sessionString;
        const userToken = tokenString && JSON.parse(tokenString);
        return userToken?.token ?? null;
    });

    const saveToken = useCallback((userToken, rememberMe = false) => {
        sessionStorage.setItem('token', JSON.stringify(userToken));
        const alreadyRemembered = !!localStorage.getItem('token');
        if (rememberMe || alreadyRemembered) {
            localStorage.setItem('token', JSON.stringify(userToken));
        }
        setTokenState(userToken.token);
    }, []);

    const removeToken = useCallback(() => {
        sessionStorage.removeItem('token');
        localStorage.removeItem('token');
        setTokenState(null);
    }, []);

    return {
        setToken: saveToken,
        removeToken,
        token,
    };
}
